import tableRowRules from '../../table/row-line';

const secondary = (params) => tableRowRules.secondary(params);

export default secondary;
